<template>
  <input
      class="border p-2 rounded-lg text-black disabled:bg-gray-500 disabled:opacity-50 disabled:cursor-not-allowed"
      :placeholder="placeholder"
      :disabled="disabled"
      :type="type"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value);"
      @keydown="$emit('keydown')"
      :class="{'border border-red-500' : error}">
</template>

<script>
export default {
  name: "VInput",
  props: ['placeholder', 'type', 'modelValue', 'disabled', 'error'],
}
</script>

<style scoped>

</style>